import { ETH } from '../constants/assets'
import type { ChainConfig } from '../types'
import { getQuickNodeRpcUrl } from '../utils/getQuickNodeRpcUrl'

export const ARBITRUM = {
  name: 'arbitrum',
  chainId: 42161,
  averageBlockTimeSeconds: 0.25,
  explorerUrl: 'https://arbiscan.io',
  nativeAsset: ETH,
  slip44: 60,
  wrappedNativeAsset: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
  blockscoutApiUrl: 'https://arbitrum.blockscout.com/api',
  etherscanSupported: true,
  publicRpcUrls: ['https://arbitrum.drpc.org', 'https://1rpc.io/arb', 'https://arbitrum.meowrpc.com'],
  getPrivateRpcUrls: () => {
    const arbitrum: string[] = []
    process.env.ROUTEME_API_KEY && arbitrum.push(`https://lb.routeme.sh/rpc/42161/${process.env.ROUTEME_API_KEY}`)
    const quickNodeUrl = getQuickNodeRpcUrl('arbitrum')
    quickNodeUrl && arbitrum.push(quickNodeUrl)
    process.env.INFURA_API_KEY && arbitrum.push(`https://arbitrum-mainnet.infura.io/v3/${process.env.INFURA_API_KEY}`)
    process.env.ALCHEMY_API_KEY && arbitrum.push(`https://arb-mainnet.g.alchemy.com/v2/${process.env.ALCHEMY_API_KEY}`)
    process.env.ANKR_API_KEY && arbitrum.push(`https://rpc.ankr.com/arbitrum/${process.env.ANKR_API_KEY}`)
    return arbitrum
  },
} as const satisfies ChainConfig
